import { PreviewCard } from '@telus-uds/components-web'

import { BlogUrl } from 'src/blogBuilder/utils/blogUrl'
import BBImage from '../../Image'

import type { TypeArticleFields, TypeArticleWithoutUnresolvableLinksResponse } from '@/bb-contentful-types'
import type { AssetFields, AssetFile } from 'contentful'

type Props = {
  fullBlogUrls: BlogUrl
  lang: 'en' | 'fr'
  category?: string
  fullArticleUrl: string
  article: TypeArticleWithoutUnresolvableLinksResponse['fields']
}

const ArticlePreview = ({ article, lang, fullArticleUrl, fullBlogUrls }: Props) => {
  if (!article || !fullArticleUrl) {
    return null
  }

  const publishDate = new Date(article?.publishDate).toLocaleDateString(`${lang}-CA`, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })

  const { file, description, title } = (article?.image?.fields as AssetFields) || {}
  const finalUrl = (file as AssetFile)?.url || ''

  const url = `${fullBlogUrls?.hostName}${fullBlogUrls?.currentLang}/${fullArticleUrl}`

  const { height, width } = (file as AssetFile)?.details?.image || {}

  const media = {
    alt: article?.title,
    content: (
      <BBImage
        placeholder="blur"
        blurDataURL={finalUrl}
        height={height}
        width={width}
        src={'https:' + finalUrl}
        alt={description || title}
      />
    ),
  }

  return (
    <PreviewCard
      testID="article-column-bb"
      href={url}
      tag={publishDate}
      title={article.title}
      fullBleedContent={media}
    />
  )
}

export default ArticlePreview
